import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { SmallSwiper } from '../../components/swipper/SmallSwiper'

export const RegisterWithPage: React.FunctionComponent = () => {

    const { logoURL } = useSelector((store: any) => (store.ui));

    return (
        <div className='flex flex-col justify-center items-center h-full absolute w-full'>

            <div className='mb-8'>
                <img src={logoURL} alt="Hotel logo" width={'220px'} />
            </div>
            <div className='mt-4'>

                <SmallSwiper />

            </div>
            <div className='flex flex-col w-full p-4 max-w-md mt-16'>
                <Link to="/auth/login"><button className="primary_btn hover:primary_btn text-white font-bold py-2 px-4 w-full">
                    Iniciar sesión
                </button></Link>
                <Link to="/auth/registro"><button className="primary_btn hover:primary_btn text-white font-bold py-2 px-4 w-full mt-4">
                    Crear una cuenta
                </button></Link>
            </div>
        </div>
    )
}
